(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cookie-banner"]) return;
  try {
    
        let cookie_banner = document.querySelector('#cookie-banner');
        let cookie_confirm_button = document.querySelector('#confirmCookies');

        if (localStorage.cookiesConfirmed == 1) {
          cookie_banner.hidden = true;
        }

        cookie_confirm_button.addEventListener('click', function(){
          localStorage.cookiesAcknowledged = 1;
          cookie_banner.hidden = true;
          return true;
        });

        verifyCookieFeatures();

        function verifyCookieFeatures(){
          // https://developers.google.com/analytics/devguides/collection/analyticsjs/user-opt-out
          if(localStorage.cookiesAcknowledged == 1){
            cookie_banner.hidden = true;
          }

          // disable ga tracking for id specified
          window['ga-disable-' + trackingCode] = true;
        }
      
  } catch(e) { console.error(e); }
})();
})();
